import { createContext } from 'react'

// 매장 정보 전역에 생성
// Context 생성
const StoreContext = createContext()

export default StoreContext
